import React from 'react';
import { CheckCircle2 } from 'lucide-react';

const TrustBadge = () => {
  return (
    <div className="relative mt-12 md:mt-16">
      {/* Subtle glow effect */}
      <div className="absolute inset-0 bg-gradient-to-r from-transparent via-[#59d862]/5 to-transparent rounded-2xl blur-2xl" />
      
      {/* Content */}
      <div className="relative flex flex-col md:flex-row items-center justify-center gap-4 md:gap-8 py-6">
        {/* Logo */}
        <div className="flex-shrink-0">
          <img
            src="/powered-by-agents-capital.png"
            alt="Powered by AgentsCapital"
            className="h-10 md:h-12 w-auto opacity-90"
          />
        </div>

        {/* Divider */}
        <div className="hidden md:block h-12 w-px bg-gradient-to-b from-transparent via-white/20 to-transparent" />

        {/* Floating Stats Badge with Animation */}
        <div className="floating-badge flex items-center gap-3 px-5 py-3.5 bg-gradient-to-r from-[#59d862]/10 to-transparent border border-[#59d862]/30 rounded-2xl shadow-[0_4px_20px_rgba(89,216,98,0.15)] hover:shadow-[0_6px_30px_rgba(89,216,98,0.25)] transition-shadow duration-300">
          <div className="flex items-center justify-center w-9 h-9 rounded-xl bg-[#59d862]/20">
            <CheckCircle2 className="w-5 h-5 text-[#59d862]" />
          </div>
          <span className="text-white font-semibold text-base md:text-lg whitespace-nowrap">
            £9M+ Paid Out
          </span>
        </div>

        {/* Divider */}
        <div className="hidden md:block h-12 w-px bg-gradient-to-b from-transparent via-white/20 to-transparent" />

        {/* Message - Optimized for mobile */}
        <p className="text-white/70 text-base md:text-lg text-center md:text-left max-w-xl leading-relaxed px-4 md:px-0">
          Gazeal Advance is built on <span className="text-[#59d862] font-medium">AgentsCapital's proven process</span> which is trusted by agents across the UK.
        </p>
      </div>
    </div>
  );
};

export default TrustBadge;
